import React from 'react';
import styles from './styles.module.css';

import PillButton from '../../../pill-button';
import Tooltip from '../../../Tooltip';

export default ({
  submitText,
  submitOnClick,
  submitDisabled,
  submitDisabledMessage,

  cancelText,
  cancelOnClick,
}) => {
  const submitButton = (
    <PillButton
      id="submit-form"
      type="submit"
      preventDefault
      text={submitText}
      onClick={submitOnClick}
      disabled={submitDisabled}
    />
  );

  return (
    <div className={styles.container}>
      {/* If the submit button is disabled then wrap it in a tooltip */}
      {submitDisabled ? (
        <Tooltip above error text={submitDisabledMessage}>
          {submitButton}
        </Tooltip>
      ) : (
        submitButton
      )}

      <PillButton
        preventDefault
        theme="grey-ghost"
        text={cancelText}
        onClick={cancelOnClick}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/form-buttons/index.js